export const randomIntFromInterval = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1) + min)
};

export const arrayToEnglishList = (array, conjunction) => {
  return array
    .join(", ")
    .replace(/, ((?:.(?!, ))+)$/, ` ${conjunction} $1`);
};

export function ucfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export async function preloadImage(url) {
  // console.log('preloadImage', url);
  let img = new Image();
  img.crossOrigin = "anonymous";
  img.src = url;
}

export async function preloadPdf(url) {
  let ifrm = document.createElement("iframe");
  ifrm.setAttribute("src", url);
}

// cf. https://stackoverflow.com/questions/22172604/convert-image-from-url-to-base64
export const imageUrlToBase64 = async (url) => {
  console.log('imageUrlToBase64', url);
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
    reader.onerror = reject;
  });
};
